var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppleIcon = function SvgAppleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#232323",
    fillRule: "evenodd",
    d: "M15.71.906c0 1.035-.458 2.071-1.104 2.819-.686.826-1.87 1.442-2.812 1.442-.107 0-.215-.013-.282-.026a1.76 1.76 0 0 1-.04-.367c0-1.05.551-2.085 1.143-2.74.753-.853 2.005-1.495 3.054-1.535.027.118.04.262.04.407Zm3.7 6.524.052-.034c-1.4-1.954-3.525-2.006-4.117-2.006-.905 0-1.714.312-2.395.575-.494.191-.92.356-1.264.356-.38 0-.817-.172-1.303-.364-.614-.241-1.308-.515-2.074-.515-2.583 0-5.206 2.085-5.206 6.018 0 2.452.968 5.035 2.166 6.7 1.035 1.416 1.937 2.57 3.228 2.57.613 0 1.062-.186 1.534-.381.524-.217 1.076-.445 1.91-.445.843 0 1.347.214 1.833.421.453.193.89.379 1.571.379 1.413 0 2.341-1.246 3.229-2.491.995-1.416 1.413-2.806 1.426-2.872-.08-.026-2.785-1.088-2.785-4.09 0-2.417 1.842-3.595 2.194-3.82Z",
    clipRule: "evenodd"
  })));
};
export default SvgAppleIcon;